var body = 'body_body__1cr9mb0';

export { body };
//# sourceMappingURL=body.vanilla.mjs.map
